import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import ReactApexChart from "react-apexcharts";
// import Plot from 'react-plotly.js';
// import {  useLayoutEffect, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { useRef } from 'react';


import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ApexCharts from "apexcharts";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const MainDashboard = () => {
  const [menu, setMenu] = useState(false);
  const [cusomerbalance, setCusomerbalance] = useState([]);
  //const [cusomerrevenues, setCusomerrevenues] = useState([]);
  const [cusomerrevenues, setCusomerrevenues] = useState({
    currency: [],
    customer_names: [],
    sum_paid_all: [],
    open_amount_all: []
  });
  const [dataacaliber, setDataacaliber] = useState([]);
  const [customerpayment, setCustomerpayment] = useState([]);
  const [customernetweight, setCustomernetweight] = useState([]);

  // const [dateprices, setDateprices] = useState([]);
  const [dateavgprices, setDateavgprices] = useState([]);
  const [dateavgpricesdaily, setDateavgpricesdaily] = useState([]);



  const [productnameLists, setproductnameLists] = useState([]);
  const [dataBoxes, setDataBoxes] = useState([]);
  const [customertotalreceivedopen, setCustomertotalreceivedopen] = useState({});
  const [formData, setFormData] = useState({
    startDate: '',
    endDate: '',
    product: 1,
  });
  useEffect(() => {


    axios
      .post(
        "/products/listing-groupby",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          // setBarcodeProducts(products);
          console.log(products);
          let productslisting = products.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `prodct-${index}`,
          }));
          setproductnameLists(productslisting);
          if (productslisting.length) {
            // setFormData((f) => ({ ...f, product: productslisting[0].value }));
          }
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    //fetchDateLocation();


  }, []);

  let all_season = localStorage.getItem("all_seasons");
  const allseason = all_season ? JSON.parse(all_season) : [];

  function getStartOfWeek(date) {
    const d = new Date(date);
    const day = d.getDay(); // Sunday = 0
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
    return new Date(d.setDate(diff));
  }

  function getStartOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  function getEndOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function getStartOfYear(date) {
    return new Date(date.getFullYear(), 0, 1);
  }
  function getEndOfYear(date) {
    return new Date(date.getFullYear(), 11, 31);
  }

  const now = new Date();

  const lastYearStart = new Date(now.getFullYear() - 1, 0, 1);
  const lastYearEnd = new Date(now.getFullYear() - 1, 11, 31);
  // const season_start1 = new Date(season_start);
  // const season_end1 = new Date(season_end);

  const predefinedRanges = [
    {
      label: 'This Week',
      value: [getStartOfWeek(now), now],
      closeOverlay: true,
      status: 0
    },
    {
      label: 'This Month',
      value: [getStartOfMonth(now), getEndOfMonth(now)],
      closeOverlay: true,
      status: 0
    },
    {
      label: 'This Year',
      value: [getStartOfYear(now), getEndOfYear(now)],
      closeOverlay: true,
      status: 0
    },
    {
      label: 'Last Year',
      value: [lastYearStart, lastYearEnd],
      closeOverlay: true,
      status: 0
    },
    // {
    //   label: 'Current Season Range',
    //   value: [season_start1, season_end1],
    //   closeOverlay: true,
    //   status: 0
    // }
  ];

  // payload builder
  // const getDateLocationPayload = () => ({
  //   startDate: formData.startDate,
  //   endDate: formData.endDate,
  //   product: formData.product
  // });
  // console.log(getDateLocationPayload);
  allseason.map(item => {
    let inner_arr = {}
    inner_arr.label = item.name;
    inner_arr.value = [new Date(item.start), new Date(new Date(item.end))];
    inner_arr.closeOverlay = true;
    inner_arr.status = item.status;
    predefinedRanges.push(inner_arr);
  });


  const defaultRange = predefinedRanges.find(range => range.status == 1)?.value || predefinedRanges[0].value;


  const [value, setValue] = useState(defaultRange); // index 2 is "This Year"

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  // useEffect(() => {
  //   fetchDashboardData(value);
  // }, []);
  useEffect(() => {
    if (!formData.product) return;      // don’t fire until product exists
    fetchDashboardData(value);
  }, [value, formData.product]);
  // console.log(formData);
  const fetchDashboardData = (range) => {

    const startDate = toLocalDateString(range[0]);
    const endDate = toLocalDateString(range[1]);

    const formattedRange = {
      startDate,
      endDate
    };


    axios.post("/dashboard/top-boxes", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          setDataBoxes(response.data.data);
        } else {
          setTimeout(() => {
            window.location.href = "/login";
          }, 500);
        }
      }).catch((error) => {
        console.log(error);
      });


    axios.post("/dashboard/customer-netweight", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let dataa = response.data.data.customers;
          const customerNames = dataa.map(item => item.company_name);
          const netWeights = dataa.map(item => item.total_net_weight);
          const colors = dataa.map(item => item.color);
          // const colors = customerNames.map(() => getRandomColor());

          const chartData = {
            labels: customerNames,
            series: netWeights,
            colors: colors
          };
          setCustomernetweight(chartData)

          //console.log(customernetweight);
        }
      }).catch((error) => {
        console.log(error);
      });


    axios.post("/dashboard/customers-revenues", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let call_customer = response.data.data.customers;
          const receivedAmount = call_customer.reduce((sum, c) => sum + Number(c.paid_amount), 0);
          const totalOpenAmount = call_customer.reduce((sum, c) => sum + Number(c.open_amount), 0);

          const customerDatatotal = {
            received: receivedAmount,
            open: totalOpenAmount
          };

          setCustomertotalreceivedopen(customerDatatotal)


          const customerData = {
            customer_names: call_customer.map(c => c.company_name),
            currency: call_customer.map(c => c.currency.symbol),
            sum_paid_all: call_customer.map(c => c.paid_amount),
            open_amount_all: call_customer.map(c => c.open_amount)
          };
          setCusomerrevenues(customerData)
        }
      }).catch((error) => {
        console.log(error);
      });
    axios.post("/dashboard/customers-balances", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          setCusomerbalance(response.data.data.customers);

        }
      }).catch((error) => {
        console.log(error);
      });

    axios.post("/dashboard/product-quantity-analytics", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        setDataacaliber(response.data.data);
        // console.log(dataacaliber);

      }).catch((error) => {
        console.log(error);
      });

    axios.post(
      "/dashboard/trader-farmer-supplier-cost-new",
      formattedRange,
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
      .then((response) => {
        let all_supplier = response.data.data.suppliers;
        //console.log(all_supplier);
        const topSuppliers = all_supplier
          .map(supplier => ({
            ...supplier,
            situation: parseFloat(supplier.situation.replace(/,/g, ''))
          }))
          .sort((a, b) => b.situation - a.situation)
          .slice(0, 10);

        setCustomerpayment(topSuppliers);
      })
      .catch((error) => {
        console.log(error);
      });



    const product = formData.product;
    // console.log(product);



    axios.post("/dashboard/datelocation-new2", { ...formattedRange, product }, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let dataa = response.data.data.avg_price;
          setDateavgprices(dataa)
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios.post("/dashboard/datelocation-new-daywise", { ...formattedRange, product }, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let dataa = response.data.data.avg_price;
          setDateavgpricesdaily(dataa)
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }


  const toLocalDateString = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const handleDateChange2 = (item) => {
    if (!item || !Array.isArray(item) || item.length < 2) {
      console.warn("Invalid date range selected:", item);
      return;
    }

    setValue(item);

    // const startDate = toLocalDateString(item[0]);
    // const endDate = toLocalDateString(item[1]);

    const startDate = toLocalDateString(item[0]);
    const endDate = toLocalDateString(item[1]);

    const formattedRange = {
      startDate,
      endDate
    };
    // // update state for later if you need it elsewhere
    // setFormData((f) => ({ ...f, startDate, endDate }));


    // const payload = { startDate, endDate, product: formData.product };

    axios.post("/dashboard/top-boxes", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          setDataBoxes(response.data.data);
        } else {
          setTimeout(() => {
            window.location.href = "/login";
          }, 500);
        }
      }).catch((error) => {
        console.log(error);
      });


    axios.post("/dashboard/customer-netweight", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let dataa = response.data.data.customers;
          const customerNames = dataa.map(item => item.company_name);
          const netWeights = dataa.map(item => item.total_net_weight);
          const colors = dataa.map(item => item.color);
          // const colors = customerNames.map(() => getRandomColor());

          const chartData = {
            labels: customerNames,
            series: netWeights,
            colors: colors
          };
          setCustomernetweight(chartData)

          //console.log(customernetweight);
        }
      }).catch((error) => {
        console.log(error);
      });


    axios.post("/dashboard/customers-revenues", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let call_customer = response.data.data.customers;
          const customerData = {
            customer_names: call_customer.map(c => c.company_name),
            currency: call_customer.map(c => c.currency.symbol),
            sum_paid_all: call_customer.map(c => c.paid_amount),
            open_amount_all: call_customer.map(c => c.open_amount)
          };
          setCusomerrevenues(customerData)
        }
      }).catch((error) => {
        console.log(error);
      });
    axios.post("/dashboard/customers-balances", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          setCusomerbalance(response.data.data.customers);

        }
      }).catch((error) => {
        console.log(error);
      });

    axios.post("/dashboard/product-quantity-analytics", formattedRange, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        console.log(response.data.data);
        setDataacaliber(response.data.data);

      }).catch((error) => {
        console.log(error);
      });

    axios.post(
      "/dashboard/trader-farmer-supplier-cost-new",
      formattedRange,
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
      .then((response) => {
        let all_supplier = response.data.data.suppliers;
        //console.log(all_supplier);
        const topSuppliers = all_supplier
          .map(supplier => ({
            ...supplier,
            situation: parseFloat(supplier.situation.replace(/,/g, ''))
          }))
          .sort((a, b) => b.situation - a.situation)
          .slice(0, 10);

        setCustomerpayment(topSuppliers);
      })
      .catch((error) => {
        console.log(error);
      });



  };




  const invoiceOptions = {
    colors: customernetweight.colors || [],
    chart: {
      fontFamily: "Poppins, sans-serif",
      height: 350,
      type: "donut",
    },
    series: customernetweight.series || [],
    labels: customernetweight.labels || [],
    legend: {
      show: true,
      position: 'bottom'
    },
    dataLabels: {
      formatter: function (val, opts) {
        const value = opts.w.config.series[opts.seriesIndex];
        return `${value} KG`;
      }
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${val} KG`;
        }
      }
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 400,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };


  useEffect(() => {


  }, []);

  useEffect(() => {
    if (customernetweight.series && customernetweight.series.length > 0) {
      let invoiceColumn = document.getElementById("invoice_chart");
      let invoiceChart = new ApexCharts(invoiceColumn, invoiceOptions);
      invoiceChart.render();
    }
  }, [customernetweight]);

  const sColStacked = useMemo(() => ({
    chart: {
      height: 350,
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },
    colors: ["#1B2E6B", "#0070C0"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "20%",
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        fontSize: "12px",
        colors: ["#000"],
      },
      offsetY: -6,
      formatter: function (val, opts) {
        const dataPointIndex = opts.dataPointIndex;
        const currency = (cusomerrevenues.currency && cusomerrevenues.currency[dataPointIndex]) || '';
        return val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + currency;
      }
    },
    tooltip: {
      y: {
        formatter: function (val, opts) {
          const dataPointIndex = opts.dataPointIndex;
          const currency = (cusomerrevenues.currency && cusomerrevenues.currency[dataPointIndex]) || '';
          return val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + currency;
        }
      }
    },
    yaxis: {
      labels: {
        formatter: val => val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        style: { fontSize: "12px" }
      },
    },
    series: [
      {
        name: "Paid",
        data: Array.isArray(cusomerrevenues.sum_paid_all) && cusomerrevenues.sum_paid_all.length > 0
          ? cusomerrevenues.sum_paid_all.map(v => Number(v) || 0)
          : []
      },
      {
        name: "Open",
        data: Array.isArray(cusomerrevenues.open_amount_all) && cusomerrevenues.open_amount_all.length > 0
          ? cusomerrevenues.open_amount_all.map(v => Number(v) || 0)
          : []
      },
    ],
    xaxis: {
      type: "category",
      categories: Array.isArray(cusomerrevenues.customer_names) ? cusomerrevenues.customer_names : [],
      labels: {
        rotate: -45,
        style: { fontSize: "12px" },
      },
    },
    legend: {
      position: "right",
      offsetY: 40,
      fontSize: "13px",
      itemMargin: { vertical: 5 }
    },
    fill: { opacity: 1 }
  }), [cusomerrevenues]);


  const numberFormatter = (val) =>
    val.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' KG';

  const sColStacked_caliber = {
    chart: {
      type: "bar",
      height: 350,
      stacked: false,      // ← disable stacking
      toolbar: { show: false },
    },
    colors: ['#1B2E6B', '#0070C0'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%', // make them a bit wider since they're no longer stacked
      },
    },
    dataLabels: {
      enabled: false,  // ← ye line add ki hai to remove values from bars
      formatter: numberFormatter, // ✅ if you enable later

    },
    series: [
      {
        name: "Quantity",
        data: dataacaliber.quantity || [],
      },
      {
        name: "Remaining Quantity",
        data: dataacaliber.remaining_quantity || [],
      },
    ],
    xaxis: {
      type: "category",
      categories: dataacaliber.products || [],
      labels: {
        rotate: -45,
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      labels: {
        formatter: numberFormatter, // ✅ Y-axis numbers
        style: { fontSize: "12px" },
      },
    },

    tooltip: {
      y: {
        formatter: numberFormatter, // ✅ Tooltip values
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
  };

  const [profileImages, setProfileImages] = useState({});

  useEffect(() => {
    const fetchAllImages = async () => {
      const s3Client = new S3Client({
        region: AWS_DEFAULT_REGION,
        credentials: {
          accessKeyId: AWS_ACCESS_KEY_ID,
          secretAccessKey: AWS_SECRET_ACCESS_KEY,
        },
      });

      const urls = {};
      for (const item of cusomerbalance) {
        if (item.company_logo) {
          try {
            const command = new GetObjectCommand({
              Bucket: AWS_BUCKET,
              Key: item.company_logo,
            });
            const url = await getSignedUrl(s3Client, command, { expiresIn: 3600 });
            urls[item.company_logo] = url;
          } catch (error) {
            console.error("Error fetching signed URL for", item.company_logo, error);
            urls[item.company_logo] = null; // optional fallback
          }
        }
      }
      setProfileImages(urls);
    };

    fetchAllImages();
  }, [cusomerbalance]);

  const downloadpdf = () => {
    const input = document.getElementById('downloadpdf');

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0]; // YYYY-MM-DD
      const fileName = `Admin Dashboard ${formattedDate}.pdf`;
      pdf.save(fileName);
    });
  };

  const viewReceiption = () => {
    window.location.href = "/raw-materials";

  }
  const viewFinalProducts = () => {
    localStorage.setItem('tableColumnFilters', JSON.stringify([{ "id": "total_output_type", "value": "Finished" }]));
    window.location.href = "/production-output/";

  }

  const viewSemiFinalProducts = () => {
    localStorage.setItem('tableColumnFilters', JSON.stringify([{ "id": "total_output_type", "value": "Semi Finished" }]));
    window.location.href = "/production-output/";

  }
  const handleSelectChangeCustomer = (selectedOption) => {
    console.log("selectedOption"); console.log(selectedOption);
    setFormData(f => ({ ...f, product: selectedOption.value }));

    console.log("here");
    console.log("formData");
    console.log(formData);


  };
  
  
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [viewMode, setViewMode] = useState('weekly'); // 'weekly' or 'daily'
  const chartRef = useRef(null);

  // Get current data based on view mode
  const currentData = viewMode === 'weekly'
    ? (selectedWeek && dateavgprices?.dailyDataByWeek?.[selectedWeek]
      ? dateavgprices.dailyDataByWeek[selectedWeek]
      : dateavgprices?.weeklyData)
    : null;

  // Prepare daily data
  // const sortedData = dateavgpricesdaily ? [...dateavgpricesdaily].reverse() : [];
  const sortedData = dateavgpricesdaily;
  const dates = sortedData.map(item => item.shift_date);
  const aGradePrices = sortedData.map(item => item.a_grade_avg_price);
  const bGradePrices = sortedData.map(item => item.b_grade_avg_price);

  // Combined chart option with daily graph layout
  const chartOption = {
    title: {
      text: viewMode === 'weekly'
        ? 'Weekly Average Price Analytics'
        : 'Daily Average Price Analytics',
      left: 'center',
      textStyle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#333'
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      },
      formatter: function (params) {
        let result = `<b>${params[0].axisValue}</b><br/>`;
        params.forEach(param => {
          if (param.value > 0) {
            result += `${param.marker} ${param.seriesName}: <b>${param.value} MAD</b><br/>`;
          } else {
            result += `${param.marker} ${param.seriesName}: <b>N/A</b><br/>`;
          }
        });
        return result;
      }
    },
    legend: {
      data: ['Grade A Average Price', 'Grade B Average Price'],
      bottom: 0,
      padding: [60, 0, 0, 0]  // Added padding: [top, right, bottom, left]
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: viewMode === 'weekly' ? (currentData?.labels || []) : dates,
      axisLabel: {
        rotate: 45,
        interval: 0,
        fontSize: 10
      },
      name: '',
      nameLocation: 'middle',
      nameGap: 50
    },
    yAxis: {
      type: 'value',
      name: 'Price (MAD)',
      axisLabel: {
        formatter: (value) => value.toLocaleString() + ' MAD'
      }
    },
    dataZoom: [
      {
        type: 'inside',
        start: 0,
        end: 100,
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        preventDefaultMouseMove: false
      },
      {
        type: 'slider',
        start: 0,
        end: 100,
        handleSize: '80%',
        handleStyle: {
          color: '#fff',
          shadowBlur: 3,
          shadowColor: 'rgba(0, 0, 0, 0.6)',
          shadowOffsetX: 2,
          shadowOffsetY: 2
        }
      }
    ],
    series: [
      {
        name: 'Grade A Average Price',
        type: 'line',
        smooth: true,
        data: viewMode === 'weekly' ? (currentData?.data1 || []) : aGradePrices,
        lineStyle: {
          color: '#1B2E6B',
          width: 3
        },
        itemStyle: {
          color: '#1B2E6B',
          borderWidth: 2,
          borderColor: '#fff'
        },
        emphasis: {
          scale: true,
          focus: 'series',
          itemStyle: {
            borderWidth: 4,
            borderColor: '#fff',
            shadowBlur: 10,
            shadowColor: '#1B2E6B'
          }
        },
        areaStyle: {
          color: 'rgba(27, 46, 107, 0.1)'
        },
        symbol: 'circle',
        symbolSize: 8,
        showSymbol: true,
        hoverAnimation: true
      },
      {
        name: 'Grade B Average Price',
        type: 'line',
        smooth: true,
        data: viewMode === 'weekly' ? (currentData?.data2 || []) : bGradePrices,
        lineStyle: {
          color: '#0070C0',
          width: 3
        },
        itemStyle: {
          color: '#0070C0',
          borderWidth: 2,
          borderColor: '#fff'
        },
        emphasis: {
          scale: true,
          focus: 'series',
          itemStyle: {
            borderWidth: 4,
            borderColor: '#fff',
            shadowBlur: 10,
            shadowColor: '#0070C0'
          }
        },
        areaStyle: {
          color: 'rgba(0, 112, 192, 0.1)'
        },
        symbol: 'circle',
        symbolSize: 8,
        showSymbol: true,
        hoverAnimation: true
      }
    ]
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">

          <div className="content container-fluid top-dashboardfilter" >

            <div className="row" >

              <div className="col-md-6">

                <label><b>Select The Date Range</b></label><br />
                <DateRangePicker
                  value={value}
                  className="dashboard-daterange"
                  // onChange={setValue}
                  onChange={handleDateChange2}
                  placeholder="Select Date Range"
                  //style={{ width: '100%' }}
                  ranges={predefinedRanges}
                  showOneCalendar={false}
                />

              </div>

              <div className="col-md-6">
                <div className="" style={{ float: 'right' }}>
                  <button onClick={downloadpdf} className="btn btn-primary me-1" >
                    Export PDF <i className="fa fa-download" />
                  </button>
                </div>
              </div>

            </div>
          </div>




          <div className="content container-fluid main-dashboard-contain" id="downloadpdf">



            <div className="row" >
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-database"></i> Overview</h5><hr /></div>
                      <div className="col-xl-6 col-sm-6 col-12">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site2">
                            <i className="fa fa-balance-scale	"></i>
                          </span>
                          <div className="dash-count">
                            <div className="dash-title">Total Net Weight</div>
                            <div className="dash-counts">
                              <p>{dataBoxes.total_net_weight} (KG)</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6 col-12">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site">
                            <i className="fas fa-file-alt"></i>
                          </span>
                          <div className="dash-count">
                            <div className="dash-title">Number Of Loads</div>
                            <div className="dash-counts">
                              <p>{dataBoxes.number_of_loads}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-bars	"></i> Invoice Statistics</h5><hr /></div>
                      <div className="col-xl-6 col-sm-6 col-12">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site3">
                            <i className="fas fa-euro"></i>
                          </span>
                          <div className="dash-count">
                            <div className="dash-title">Total sales </div>
                            <div className="dash-counts">
                              <p>{dataBoxes.total_amount}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6 col-12">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site2">
                            <i className="fas fa-euro"></i>
                          </span>
                          <div className="dash-count">
                            <div className="dash-title">Total Credit Note</div>
                            <div className="dash-counts">
                              <p>{dataBoxes.credit_note}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>


              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-align-justify"></i> Sale Analytics</h5><hr /></div>
                      <div className="col-xl-6 col-sm-6 col-12">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site">
                            <i className="far fa-file"></i>
                          </span>
                          <div className="dash-count">
                            <div className="dash-title">Total Received</div>
                            <div className="dash-counts">
                              <p>{Number(customertotalreceivedopen.received).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6 col-12">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site3">
                            <i className="fas fa-file-alt"></i>
                          </span>
                          <div className="dash-count">
                            <div className="dash-title">Total Pending</div>
                            <div className="dash-counts">
                              <p>{Number(customertotalreceivedopen.open).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>



              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-database"></i> Total receptions</h5><hr /></div>
                      <div className="col-xl-12 col-sm-12 col-12">
                        <div className="card-body">
                          <div className="dash-widget-header">
                            <span className="dash-widget-icon bg-site3">
                              <i className="fas fa-shopping-basket"></i>
                            </span>
                            <div className="dash-count">

                              <div className="dash-counts">
                                <p>{dataBoxes.bl_net_weight}(KG)</p>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <p className=" mt-3 mb-0">
                            <button onClick={() => viewReceiption()} className="btn btn-link color-site me-1"  > View Receptions  </button>
                            {/* <a href="/raw-materials"> <i className="fas fa-file me-1"></i> View Receptions</a> */}
                          </p>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>





              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-database"></i> Total Finised Product</h5><hr /></div>
                      <div className="col-xl-12 col-sm-12 col-12">
                        <div className="card-body">
                          <div className="dash-widget-header">
                            <span className="dash-widget-icon bg-site2">
                              <i className="fa fa-hashtag"></i>
                            </span>
                            <div className="dash-count">

                              <div className="dash-counts">
                                <p>{dataBoxes.production_final_net_weight} (KG)</p>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <p className=" mt-3 mb-0">
                            <button onClick={() => viewFinalProducts()} className="btn btn-link color-site me-1"  > View Finished Products  </button>
                          </p>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>



              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12 col-12"><h5> <i className="fas fa-database"></i> Total Semi Finished Product</h5><hr /></div>
                      <div className="col-xl-12 col-sm-12 col-12">
                        <div className="card-body">
                          <div className="dash-widget-header">
                            <span className="dash-widget-icon bg-site2">
                              <i className="fa fa-hashtag"></i>
                            </span>
                            <div className="dash-count">

                              <div className="dash-counts">
                                <p>{dataBoxes.production_final_decay} (KG)</p>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <p className=" mt-3 mb-0">
                            <button onClick={() => viewSemiFinalProducts()} className="btn btn-link color-site me-1"  > View Semi Finished Products  </button>
                          </p>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>


            </div>



            <div className="row">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Customers Invoices</h5>
                  </div>
                  <div className="card-body">
                    <div style={{ overflowX: 'auto', width: '100%' }}>
                      <div style={{}}> {/* Adjust width as needed */}
                        {cusomerrevenues.sum_paid_all && cusomerrevenues.sum_paid_all.length > 0 ? (
                          <ReactApexChart
                            options={sColStacked}
                            series={sColStacked.series}
                            type="bar"
                            height={350}
                          />
                        ) : (
                          <div className="text-center p-4">
                            <p>No invoice data available for the selected period</p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div id="s-col-stacked" /> */}

                  </div>
                </div>
              </div>
              <div className="col-xl-6 d-flex" >
                <div className="card flex-fill">
                  <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="card-title">Top Sale Statistics</h5>

                    </div>
                  </div>
                  <div className="card-body">
                    <div id="invoice_chart"></div>

                  </div>
                </div>
              </div>

              <div className="col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title"> Customer Balances</h5>
                      </div>
                      <div className="col-auto">
                        <Link
                          to="/customer-balances"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">


                    <div className="table-responsive">
                      <table className="table table-stripped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Customer</th>
                            <th>Total Sale</th>
                            <th>Paid Amount</th>
                            <th>Total Credit Note Amount</th>
                            <th>Open Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cusomerbalance.map((item, index) => {


                            return (
                              <tr key={index}>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to={`/customer-balances-details/${item.id}`}>

                                      <img
                                        className="aavatar avatar-sm me-2 avatar-img rounded-circle"
                                        src={profileImages[item.company_logo] || "/default-avatar.png"} // fallback if URL not ready
                                        alt="User"
                                      />
                                      {item.company_name}
                                    </Link>
                                  </h2>
                                </td>
                                <td> {Number(item.total_sale).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  {item.currency ? item.currency.symbol : ""} </td>
                                <td> {Number(item.paid_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  {item.currency ? item.currency.symbol : ""}
                                </td>
                                <td> {Number(item.credit_note_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  {item.currency ? item.currency.symbol : ""}
                                </td>
                                <td> {Number(item.open_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  {item.currency ? item.currency.symbol : ""}
                                </td>


                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Product Quantity Analytics </h5>
                  </div>
                  <div className="card-body">
                    <div style={{ overflowX: 'auto', width: '100%' }}>
                      <div > {/* Adjust width as needed */}
                        <ReactApexChart
                          options={sColStacked_caliber}
                          series={sColStacked_caliber.series}
                          type="bar"
                          height={350}
                        />
                      </div>
                    </div>

                  </div>



                </div>
              </div>


              <div className="col-md-6">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="card-title">Average Price Analytics</h5>
                    <div className="btn-group" role="group">
                      <button
                        type="button"
                        className={`btn ${viewMode === 'weekly' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => {
                          setViewMode('weekly');
                          setSelectedWeek(null);
                        }}
                      >
                        Weekly View
                      </button>
                      <button
                        type="button"
                        className={`btn ${viewMode === 'daily' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('daily')}
                      >
                        Daily View
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <Select
                      options={productnameLists}
                      name="supplier"
                      value={productnameLists.find(option => option.value === formData.product) || null}
                      onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                    />
                    <div className="w-full ">
                      {selectedWeek && viewMode === 'weekly' && (
                        <button
                          onClick={() => setSelectedWeek(null)}
                          className="mb-4 px-4 py-2 btn btn-primary rounded-lg"
                        >
                          ← Back to Weekly View
                        </button>
                      )}

                      <div className="">
                        <ReactECharts
                          key={viewMode} // Add this key prop to force re-initialization
                          ref={chartRef}
                          option={chartOption}
                          style={{ height: '400px', width: '100%' }}
                          opts={{ renderer: 'canvas' }}
                          notMerge={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">

              <div className="col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Top 10 Suppliers By Open Amount </h5>
                      </div>
                      <div className="col-auto">
                        <Link
                          to="/supplier-balances"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">

                    </div>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Customer</th>
                            <th>Total amount</th>
                            <th>Paid Amount</th>
                            <th>Open Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerpayment.map((item, index) => {

                            return (
                              <tr key={index}>
                                <td>
                                  <h2 className="table-avatar">
                                    <Link to={`/supplier-balances-detail/${item.supplier_id}`} >
                                      {item.supplier_name}
                                    </Link>
                                  </h2>
                                </td>
                                <td>{item.sum_final_amount}</td>
                                <td>{item.sum_final_payment_1_2}</td>
                                <td>{item.situation}</td>

                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </div>



          </div>
        </div>
      </div>
    </>
  );
};
export default MainDashboard;
